import React from "react";
import TimeSlot from "./TimeSlot/TimeSlot";
import "./TimeSlotHandler.css";

class TimeSlotHandler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      meetingDays: [],
    };
  }

  componentDidMount() {
    this.setState({
      meetingDays: [...this.props.meetingDays],
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.meetingDays !== this.props.meetingDays) {
      this.setState({
        meetingDays: [...this.props.meetingDays],
      });
    }
  }

  render() {
    return this.state.meetingDays !== [] ? (
      <div className="time-slot-handler">
        {this.state.meetingDays.map((d, index) => (
          <TimeSlot
            key={"timeslot_" + index}
            key_index={index}
            selectedDays={d.weekdays}
            selectedHours={d.hours}
            daySelectorName={"timeslot_" + index}
            handleTimeSlotOnChange={this.props.handleTimeSlotOnChange}
            handleDeleteTimeSlot={this.props.handleDeleteTimeSlot}
            zIndexValue={index}
          />
        ))}
      </div>
    ) : null;
  }
}

export default TimeSlotHandler;
